module.exports = __webpack_public_path__ + "img/charter-service.a8cbe19c.jpg";